
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/offene-skigebiete",
      function () {
        return require("private-next-pages/[region]/offene-skigebiete.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/offene-skigebiete"])
      });
    }
  